/**
 * Split a single "Attorney Name" input into the first/last pair the API
 * requires.
 *
 * POST /api/apply declares attorneyFirstName and attorneyLastName as
 * separate required strings, so collapsing the form to one field means
 * splitting here rather than changing the API contract.
 *
 * Splits on the LAST space so multi-word given names survive: "Mary Jane
 * Watson" is Mary Jane / Watson, not Mary / Jane Watson.
 */
export const splitAttorneyName = (full) => {
  const trimmed = (full || '').trim().replace(/\s+/g, ' ');
  if (!trimmed) return { firstName: '', lastName: '' };

  const idx = trimmed.lastIndexOf(' ');
  if (idx === -1) return { firstName: trimmed, lastName: '' };

  return {
    firstName: trimmed.slice(0, idx),
    lastName: trimmed.slice(idx + 1),
  };
};

export default splitAttorneyName;
